const getLanguageData = (language, data_eng, data_esp) => {
  return language === "esp" ? data_esp : data_eng;
};

export default getLanguageData;
